// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

    // Equal heights
    var maxHeight = 0 
    jQuery('.wp-block-columns').each( (index, elem) => {
        jQuery(elem).find('.crd h4').each( (i, el) => {
            let currentHeight = parseInt(jQuery(el).css('height'))
            maxHeight = (maxHeight < currentHeight) ? currentHeight : maxHeight
        })
        
        jQuery(elem).find('.crd h4').css('height', maxHeight)
    })

    function initCarousel() {

        if ( jQuery('.carousel-control-prev').length > 0 ) {
            jQuery('.carousel-control-prev').remove()
            jQuery('.carousel-control-next').remove()
        }

        // Carousel 
        if (jQuery('.client-carousel').length > 0) {

            let columns = 4

            if (window.innerWidth < 768) {
                columns = 2
            } else if (window.innerWidth < 992) {
                columns = 3
            }

            const colWidth = 100 / columns
            let carousel = jQuery('.client-carousel')
            let innerContainer = carousel.find('.inner-container')
            let totalColumns = carousel.find('.inner-container > figure').length

            innerContainer.css('width', totalColumns * colWidth + '%')

            //let innerContainer = jQuery(e.currentTarget).parent('.client-carousel').find('.inner-container').first()
            var colWidthInPx = parseInt(innerContainer.css('width')) / totalColumns
            innerContainer.find('figure').css('width', colWidthInPx)

            // negative margin limit
            var marginLimit = (columns - (totalColumns - 1)) * colWidthInPx

            jQuery(carousel).prepend('<a class="carousel-control-prev" role="button" data-slide="prev"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>')
            jQuery(carousel).append('<a class="carousel-control-next" role="button" data-slide="next"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>')

            var isAnimating = false

            jQuery('.carousel-control-prev').on('click', prevFigure)

            jQuery('.carousel-control-next').on('click', nextFigure)

            function prevFigure() {
                if (isAnimating) return
            
                if (jQuery(innerContainer).css('marginLeft') < '0px') {
                    isAnimating = true
                    jQuery(innerContainer).animate({
                        marginLeft: ("+="+ colWidth +"%")
                        }, "slow", () => {
                            isAnimating = false
                        });
                }
            }

            function nextFigure() {
                if (isAnimating) return

                if (parseInt(jQuery(innerContainer).css('marginLeft')) > marginLimit) {
                    isAnimating = true
                    jQuery(innerContainer).animate({
                            marginLeft: ("-="+ colWidth +"%")
                        }, "slow", () => {
                            isAnimating = false
                        });
                }
            }
        }
    }

    initCarousel()

    jQuery(window).on('resize', initCarousel)

    window.onscroll = function() {
        if (window.scrollY > 150) {
            // Execute code here when page is scrolled more than 50 pixels from the top
            document.querySelector('.home #header').style.backgroundColor = '#6e97e2'
        } else {
            document.querySelector('.home #header').style.backgroundColor = 'transparent'
        }
        console.log(window.scrollY)
    }
} )();
